import { Tooltip } from '@mui/material';
import React from 'react';
import { Img } from 'react-image';
import { useThemeContext } from 'src/context/ThemeProvider';
import { generateDifficultyColor } from 'src/utils/color';
import { QuestionDifficulty } from 'types';

interface Props {
	question: {
		serialNumber: number;
		title: string;
		level: string;
		score: number;
		timeTaken: string;
		skillsAssessed: { _id: string; name: string; isSoftSkill: boolean }[];
	};
}

const AccordianTitleQuestionComponentMobile = ({ question }: Props) => {
	const customStyleObject = {
		color: generateDifficultyColor(question.level as QuestionDifficulty),
	};
	const { themeMode } = useThemeContext();
	return (
		<div className="px-2 py-4 border-b-[1px] border-solid dark:border-[#8f90a61a] dark:bg-[#18222D] ">
			<div className="text-sm flex justify-between">
				<div className="flex dark:text-white">
					<div>{question.serialNumber}.</div>
					<div>
						<div className="max-w-[200px] truncate">{question.title}</div>
						<div style={customStyleObject} className={`text-[10px] font-medium`}>
							{question.level}
						</div>
					</div>
				</div>

				<div className="dark:text-[#F2F2F5] font-medium">
					<div className="text-base">
						{question.score}
						<span className="text-[8px]">/10</span>
					</div>
					<div className="text-xs dark:text-[#C7C9D9] leading-[12px]">{question.timeTaken}</div>
				</div>
			</div>

			<div className="mt-3 flex gap-2 flex-wrap ">
				{question?.skillsAssessed?.map(s => {
					const backgroundStyleObject =
						themeMode === 'dark'
							? {
									background: !s.isSoftSkill
										? 'linear-gradient(#242C40, #242C40) padding-box, linear-gradient(to right, #5b8def, #0063f7, #73dfe7, #0063f7)' // linear-gradient(#111E2C, #111E2C)
										: '#242C40',
							  }
							: {};

					return (
						<div
							key={s._id}
							style={backgroundStyleObject}
							className={`px-[9px] py-[1px] text-sm font-medium dark:text-[#E4E4EB] w-max rounded-[5px] border-[0.5px] ${
								s.isSoftSkill
									? 'border-solid border-[#C7D0F2] border bg-[#CDF] text-[#7777E7]'
									: 'border border-[#C7D0F2] bg-[#CDF] text-[#7777E7]'
							} `}
						>
							{s.name}

							{!s.isSoftSkill ? (
								<Tooltip title="Technical Skill">
									<span>
										<Img
											className="ml-[4px] inline-block align-text-bottom"
											loading="lazy"
											src="/assets/checkCircle.svg"
											alt="checkCircle"
											width="14"
											height="14"
										/>
									</span>
								</Tooltip>
							) : null}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default AccordianTitleQuestionComponentMobile;
